export const waitForWebsocketConnection = () => {
	return new Promise((resolve) => {
		if (window.Echo?.connector?.pusher?.connection.state === 'connected') {
			resolve(true);
		} else {
			window.Echo.connector.pusher.connection.bind('connected', () => {
				resolve(true);
			});
		}
	});
};